<template>
  <div>
    <div class="home-index-banner-body">
      <a-carousel autoplay dots-class="home-index-dots">
        <!--        <div class="home-index-banner">-->
        <!--          <img src="@/assets/img/indexbanner.jpg" />-->
        <!--          <div>-->
        <!--            <p>垫江县全域数字经济场景开放服务平台</p>-->
        <!--            <div>-->
        <!--              依托解放号软件产业互联网生态 体系和数、智、码、聚产品服务矩阵，伴行政府全域数字经济创新发展需要，快速启动以应用场景开放为切入完成全过程线上线下服务-->
        <!--            </div>-->
        <!--            <span @click="$router.push(`/login`)">立即体验</span>-->
        <!--          </div>-->
        <!--        </div>-->
        <div
          v-for="(el, index) in banners"
          :key="index"
          class="home-index-banner"
        >
          <v-img
            :attachment-id="el.attachment && el.attachment.attachmentId"
            :default-img="require('@/assets/img/index-banner2.jpg')"
            @click="handleBannerClick(el)"
          />
        </div>
      </a-carousel>
      <div
        v-if="settings.STATISTIC_HIDDEN !== 'true'"
        class="home-index-banner-info"
      >
        <div>
          <div>
            <p>
              <count-to
                :startVal="startVal"
                :endVal="statistic.sceneCount"
                :duration="1"
              ></count-to>
            </p>
            <span>应用场景</span>
          </div>
          <div>
            <p>
              <count-to
                :startVal="startVal"
                :endVal="statistic.companyCount"
                :duration="1"
              ></count-to>
            </p>
            <span>参与单位</span>
          </div>
          <div>
            <p>
              <count-to
                :startVal="startVal"
                :endVal="statistic.activityCount"
                :duration="1"
              ></count-to>
            </p>
            <span>场景活动</span>
          </div>
          <div>
            <p>
              <count-to
                :startVal="startVal"
                :endVal="statistic.achvCount"
                :duration="1"
              ></count-to>
            </p>
            <span>场景成果</span>
          </div>
          <div>
            <p>
              <count-to
                :startVal="startVal"
                :endVal="statistic.fieldCount"
                :duration="1"
              ></count-to>
            </p>
            <span>场景领域</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import countTo from "vue-count-to";
import { getHomepageBanner } from "@/api/ad";
import VImg from "@/components/VImg";
import { mapGetters } from "vuex";
import { getTotalStatistic } from "@/api/common";

export default {
  components: {
    VImg,
    countTo,
  },
  data() {
    return {
      startVal: 0,
      banners: [],
      statistic: {},
    };
  },
  computed: mapGetters(["settings"]),
  methods: {
    loadBanners() {
      getHomepageBanner().then((res) => {
        this.banners = res.data;
      });
    },
    handleBannerClick(el) {
      if (el.link) {
        window.open(`${el.link}`);
      }
    },
    loadTotalStatistic() {
      getTotalStatistic().then((res) => {
        this.statistic = res.data;
      });
    },
  },
  mounted() {
    this.loadBanners();
    this.loadTotalStatistic();
  },
};
</script>

<style lang="less" scoped>
.home-index-banner-body {
  position: relative;
  height: 520px;

  .home-index-banner {
    height: 520px;
    position: relative;

    > img {
      display: block;
      width: 100%;
      height: 100%;
    }

    > div {
      width: 1200px;
      top: 80px;
      left: 50%;
      margin-left: -600px;
      position: absolute;
      color: #fff;

      > p {
        font-size: 40px;
        line-height: 40px;
        margin-bottom: 40px;
      }

      > div {
        font-size: 16px;
        font-weight: 300;
        line-height: 26px;
        width: 560px;
        text-align: justify;
        margin-bottom: 40px;
      }

      > span {
        cursor: pointer;
        width: 120px;
        height: 40px;
        background: #1abc9c;
        line-height: 40px;
        text-align: center;
        color: #fff;
        font-size: 16px;
        font-weight: 300;
        display: block;
      }
    }
  }

  .home-index-banner-info {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(000, 000, 000, 0.2);
    backdrop-filter: blur(15px);

    > div {
      width: 1200px;
      margin: 0 auto;
      display: flex;

      > div {
        flex: 1;
        position: relative;
        height: 120px;
        color: #fff;
        padding: 37px 24px 24px;

        > p {
          font-size: 32px;
          line-height: 24px;
          margin-bottom: 18px;
        }

        > span {
          font-size: 12px;
          line-height: 12px;
          opacity: 0.4;
          display: block;
        }

        &::after {
          content: "";
          position: absolute;
          width: 1px;
          height: 40px;
          background: #ffffff;
          opacity: 0.16;
          right: 0;
          top: 50%;
          margin-top: -20px;
        }

        &:last-child {
          &::after {
            display: none;
          }
        }
      }
    }
  }
}
</style>
<style>
.home-index-dots {
  bottom: 144px !important;
}

.ant-carousel .home-index-dots li.slick-active button {
  background: #1abc9c;
}
</style>
